import { render, staticRenderFns } from "./ImportModelFileDialog.vue?vue&type=template&id=83dc82f8&scoped=true"
import script from "./ImportModelFileDialog.vue?vue&type=script&lang=ts"
export * from "./ImportModelFileDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImportModelFileDialog.vue?vue&type=style&index=0&id=83dc82f8&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dc82f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83dc82f8')) {
      api.createRecord('83dc82f8', component.options)
    } else {
      api.reload('83dc82f8', component.options)
    }
    module.hot.accept("./ImportModelFileDialog.vue?vue&type=template&id=83dc82f8&scoped=true", function () {
      api.rerender('83dc82f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialogs/ImportModelFileDialog.vue"
export default component.exports